$(() => {
  $('.js-navigation-toggle').on('click', () => {
    const $nav = $('.js-global-navigation');
    if ($nav.is(':visible')) {
      $nav.hide('fast');
    } else {
      $nav.show('fast');
    }
  });
});
